/**
 * @generated SignedSource<<96c9cc2850f5f2a2de814bf0f8bc1fc4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StreamMeetingRecapSendTo = "ALL" | "INTERNAL" | "INTERNAL_ON_FELLOW" | "NONE";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type hooksAutomations_useAnySendAutomationsEnabled_stream$data = {
  readonly automationConfigurations: ReadonlyArray<{
    readonly automation: {
      readonly codeName: string;
    };
    readonly id: string;
    readonly isActive: boolean;
  }> | null;
  readonly id: string;
  readonly meetingRecapAutoShareSource: {
    readonly __typename: "StreamMeetingRecapAutoShareSettings";
    readonly id: string;
    readonly sendTo_S: StreamMeetingRecapSendTo;
    readonly setBy: {
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
    };
  } | {
    readonly __typename: "UserMeetingRecapAutoShareSettings";
    readonly id: string;
    readonly sendTo_U: UserMeetingRecapSendTo;
    readonly user: {
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "hooksAutomations_useAnySendAutomationsEnabled_stream";
};
export type hooksAutomations_useAnySendAutomationsEnabled_stream$key = {
  readonly " $data"?: hooksAutomations_useAnySendAutomationsEnabled_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksAutomations_useAnySendAutomationsEnabled_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksAutomations_useAnySendAutomationsEnabled_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AutomationConfigurationNode",
      "kind": "LinkedField",
      "name": "automationConfigurations",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AutomationNode",
          "kind": "LinkedField",
          "name": "automation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "codeName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "meetingRecapAutoShareSource",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": "sendTo_S",
              "args": null,
              "kind": "ScalarField",
              "name": "sendTo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "setBy",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "StreamMeetingRecapAutoShareSettings",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": "sendTo_U",
              "args": null,
              "kind": "ScalarField",
              "name": "sendTo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "UserMeetingRecapAutoShareSettings",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "5938ef346da3425e5934169ccca55f27";

export default node;
